import fly from '@/utils/http';

export const getPatients = async (params) => {
  const res: any = await fly.post('/hospital/InnerHospitalArchive/getPatients', { ...params });
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};
export const getInHospitalPatientList = async (params) => {
  const res: any = await fly.post('/hospital/getInHospitalPatientList', { ...params });
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};
